import React from 'react';
import { View, StyleSheet } from 'react-native';
import { SkeletonGroup } from '../SkeletonGroup';
import { SkeletonBone } from '../SkeletonBone';
import { TransactionRowSkeleton } from '../patterns/TransactionRowSkeleton';

interface TransactionHistorySkeletonProps {
  variant?: 'row' | 'card' | 'table';
  count?: number;
  showHeader?: boolean;
}

export const TransactionHistorySkeleton: React.FC<TransactionHistorySkeletonProps> = React.memo(
  ({ variant = 'row', count = 5, showHeader = false }) => (
    <SkeletonGroup>
      {showHeader && (
        <View style={styles.tableHeader}>
          <View style={styles.cellDescription}>
            <SkeletonBone width={90} height={12} />
          </View>
          <View style={styles.cellPosted}>
            <SkeletonBone width={50} height={12} />
          </View>
          <View style={styles.cellAmount}>
            <SkeletonBone width={55} height={12} />
          </View>
        </View>
      )}
      <View style={variant === 'card' ? styles.cardGap : styles.listGap}>
        {Array.from({ length: count }).map((_, i) => (
          <TransactionRowSkeleton
            key={i}
            variant={variant === 'table' ? 'table-row' : variant}
          />
        ))}
      </View>
    </SkeletonGroup>
  ),
);

TransactionHistorySkeleton.displayName = 'TransactionHistorySkeleton';

const styles = StyleSheet.create({
  listGap: {
    gap: 0,
  },
  cardGap: {
    gap: 8,
  },
  tableHeader: {
    flexDirection: 'row',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.1)',
  },
  cellDescription: {
    flex: 2,
  },
  cellPosted: {
    flex: 1,
  },
  cellAmount: {
    flex: 1,
  },
});
